import React, { useState } from "react";
import {
  TextField,
  Typography,
  Box
} from "@mui/material";

const today = new Date();
let userAge = 0;
let isReadOnly = false;

const defaultDate = new Date(today);
defaultDate.setFullYear(today.getFullYear() - 25);
const defaultDateString = defaultDate.toISOString().split("T")[0];

/**
 * Date型オブジェクトから現在時点の年齢を計算する
 * @param birth 誕生日
 */
function CalculateAge(birth: Date) {
  if (today.getFullYear() > birth.getFullYear()) {
    userAge = today.getFullYear() - birth.getFullYear();
    if (
      today.getMonth() * 100 + today.getDate() <
      birth.getMonth() * 100 + birth.getDate()
    ) {
      userAge -= 1;
    }
  }
}

/**
 * yyyy-MM-dd HH:mm:SSをyyyy/MM/ddに変換する関数
 * @param dateString yyyy-MM-dd HH:mm:SS
 * @returns yyyy/MM/dd
 */
const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const year = date?.getFullYear();
  const month = String(date?.getMonth() + 1).padStart(2, "0");
  const day = String(date?.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * 誕生日入力エリア
 */
export const InputCalender = ({ inputItem, inputRef }: any) => {
  const [localValue, setLocalValue] = useState<string>( 
    (inputRef.current !== null && inputRef.current !== "") ? inputRef.current : inputItem ? inputItem : defaultDateString
  );

  isReadOnly = inputItem == null ? false : !(inputItem === null || inputItem === '');
  const birth = new Date(inputItem);

  if (isReadOnly) {
    CalculateAge(birth);
  }

  // 入力された値を処理
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue); // ローカルの状態を更新
    if (inputRef.current !== null) {
      inputRef.current = newValue; // useRefの値を更新
    }
    CalculateAge(new Date(newValue));
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex', // 横並びにする
          alignItems: 'center', // 垂直方向で中央揃え
          gap: 2, // カレンダーと年齢の間の余白
          width: '100%'
        }}
      >
        {/* カレンダー */}
        <TextField
          type="date"
          value={isReadOnly ? formatDate(localValue) : localValue}
          onChange={handleInputChange}
          InputProps={{
            readOnly: isReadOnly,
          }}
          fullWidth
          sx={{ backgroundColor: isReadOnly ? '#f9f9f9' : 'white' }}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          label="誕生日"
        />
        {/* 年齢 */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '4px 8px',
            borderRadius: 1,
            backgroundColor: '#f5f5f5',
            minWidth: '80px',
            justifyContent: 'center',
          }}
        >
          <Typography variant="body1">
            {userAge.toString() + '歳'}
          </Typography>
        </Box>
      </Box>
    </>
  );
};
